import { FormattedMessage } from 'react-intl';
import { UISref } from '@uirouter/react';

export const getColumns = () => {
  return [
    {
      title: 'id',
      dataIndex: 'id',
      width: 80,
      sorter: (
        a: cyrian.api.waybills.WaybillLotDetailResponseDto,
        b: cyrian.api.waybills.WaybillLotDetailResponseDto,
      ) => (a.id || 0) - (b.id || 0),
    },
    {
      title: <FormattedMessage id="waybills.lots.lotNumber" />,
      key: 'lotNumber',
      render: (_: unknown, record: cyrian.api.waybills.WaybillLotDetailResponseDto) =>
        record.lot?.number ? (
          <UISref to="base-layout.lots.view" params={{ lotId: record.lot.id }}>
            <button type="button" className="ant-btn ant-btn-link ant-btn-sm p-0">
              {record.lot.number}
            </button>
          </UISref>
        ) : (
          '-'
        ),
      sorter: (
        a: cyrian.api.waybills.WaybillLotDetailResponseDto,
        b: cyrian.api.waybills.WaybillLotDetailResponseDto,
      ) => (a.lot?.number || '').localeCompare(b.lot?.number || ''),
    },
    {
      title: <FormattedMessage id="waybills.lots.createdAt" />,
      dataIndex: 'createdAt',
      render: (date: string) => (date ? new Date(date).toLocaleString() : '-'),
      sorter: (
        a: cyrian.api.waybills.WaybillLotDetailResponseDto,
        b: cyrian.api.waybills.WaybillLotDetailResponseDto,
      ) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    },
    {
      title: <FormattedMessage id="waybills.lots.updatedAt" />,
      dataIndex: 'updatedAt',
      render: (date: string) => (date ? new Date(date).toLocaleString() : '-'),
      sorter: (
        a: cyrian.api.waybills.WaybillLotDetailResponseDto,
        b: cyrian.api.waybills.WaybillLotDetailResponseDto,
      ) => new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime(),
    },
  ];
};
